import { ToggleLeft } from '@phosphor-icons/react';

export default ToggleLeft;
